"use client";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["id", "value", "form", "name", "onChange", "by", "disabled", "defaultValue"],
  _excluded2 = ["id", "value", "disabled", "autoFocus"],
  _excluded3 = ["id", "value", "disabled", "autoFocus"];
var _ke;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useFocusRing as Q } from "@react-aria/focus";
import { useHover as Y } from "@react-aria/interactions";
import G, { createContext as Z, useCallback as ye, useContext as ee, useMemo as x, useReducer as Re, useRef as W } from "react";
import { useByComparator as be } from '../../hooks/use-by-comparator.js';
import { useControllable as ge } from '../../hooks/use-controllable.js';
import { useDefaultValue as Oe } from '../../hooks/use-default-value.js';
import { useEvent as S } from '../../hooks/use-event.js';
import { useId as B } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as te } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as oe } from '../../hooks/use-latest-value.js';
import { useSyncRefs as V } from '../../hooks/use-sync-refs.js';
import { useDisabled as re } from '../../internal/disabled.js';
import { FormFields as Pe } from '../../internal/form-fields.js';
import { useProvidedId as ve } from '../../internal/id.js';
import { isDisabledReactIssue7711 as ie } from '../../utils/bugs.js';
import { Focus as w, FocusResult as ne, focusIn as ae, sortByDomNode as De } from '../../utils/focus-management.js';
import { attemptSubmit as Ae } from '../../utils/form.js';
import { match as _e } from '../../utils/match.js';
import { getOwnerDocument as Ee } from '../../utils/owner.js';
import { forwardRefWithAs as K, mergeProps as pe, render as $ } from '../../utils/render.js';
import { Description as Ge, useDescribedBy as xe, useDescriptions as le } from '../description/description.js';
import { Keys as F } from '../keyboard.js';
import { Label as Ce, useLabelledBy as he, useLabels as se } from '../label/label.js';
var Le = function (e) {
  return e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e;
}(Le || {});
var ke = (_ke = {}, _defineProperty(_ke, 0, function _(o, t) {
    var e = [].concat(_toConsumableArray(o.options), [{
      id: t.id,
      element: t.element,
      propsRef: t.propsRef
    }]);
    return _objectSpread(_objectSpread({}, o), {}, {
      options: De(e, function (a) {
        return a.element.current;
      })
    });
  }), _defineProperty(_ke, 1, function _(o, t) {
    var e = o.options.slice(),
      a = o.options.findIndex(function (O) {
        return O.id === t.id;
      });
    return a === -1 ? o : (e.splice(a, 1), _objectSpread(_objectSpread({}, o), {}, {
      options: e
    }));
  }), _ke),
  j = /*#__PURE__*/Z(null);
j.displayName = "RadioGroupDataContext";
function J(o) {
  var t = ee(j);
  if (t === null) {
    var e = new Error("<".concat(o, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(e, J), e;
  }
  return t;
}
var X = /*#__PURE__*/Z(null);
X.displayName = "RadioGroupActionsContext";
function z(o) {
  var t = ee(X);
  if (t === null) {
    var e = new Error("<".concat(o, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(e, z), e;
  }
  return t;
}
function Fe(o, t) {
  return _e(t.type, ke, o, t);
}
var Ie = "div";
function Ue(o, t) {
  var e = B(),
    a = re(),
    _o$id = o.id,
    O = _o$id === void 0 ? "headlessui-radiogroup-".concat(e) : _o$id,
    m = o.value,
    P = o.form,
    i = o.name,
    f = o.onChange,
    c = o.by,
    _o$disabled = o.disabled,
    p = _o$disabled === void 0 ? a || !1 : _o$disabled,
    I = o.defaultValue,
    y = _objectWithoutProperties(o, _excluded),
    T = be(c),
    _Re = Re(Fe, {
      options: []
    }),
    _Re2 = _slicedToArray(_Re, 2),
    v = _Re2[0],
    C = _Re2[1],
    n = v.options,
    _se = se(),
    _se2 = _slicedToArray(_se, 2),
    U = _se2[0],
    h = _se2[1],
    _le = le(),
    _le2 = _slicedToArray(_le, 2),
    D = _le2[0],
    L = _le2[1],
    A = W(null),
    M = V(A, t),
    l = Oe(I),
    _ge = ge(m, f, l),
    _ge2 = _slicedToArray(_ge, 2),
    s = _ge2[0],
    _ = _ge2[1],
    R = x(function () {
      return n.find(function (r) {
        return !r.propsRef.current.disabled;
      });
    }, [n]),
    b = x(function () {
      return n.some(function (r) {
        return T(r.propsRef.current.value, s);
      });
    }, [n, s]),
    d = S(function (r) {
      var u;
      if (p || T(r, s)) return !1;
      var k = (u = n.find(function (H) {
        return T(H.propsRef.current.value, r);
      })) == null ? void 0 : u.propsRef.current;
      return k != null && k.disabled ? !1 : (_ == null || _(r), !0);
    }),
    de = S(function (r) {
      var k = A.current;
      if (!k) return;
      var u = Ee(k),
        H = n.filter(function (g) {
          return g.propsRef.current.disabled === !1;
        }).map(function (g) {
          return g.element.current;
        });
      switch (r.key) {
        case F.Enter:
          Ae(r.currentTarget);
          break;
        case F.ArrowLeft:
        case F.ArrowUp:
          if (r.preventDefault(), r.stopPropagation(), ae(H, w.Previous | w.WrapAround) === ne.Success) {
            var E = n.find(function (N) {
              return N.element.current === (u == null ? void 0 : u.activeElement);
            });
            E && d(E.propsRef.current.value);
          }
          break;
        case F.ArrowRight:
        case F.ArrowDown:
          if (r.preventDefault(), r.stopPropagation(), ae(H, w.Next | w.WrapAround) === ne.Success) {
            var _E = n.find(function (N) {
              return N.element.current === (u == null ? void 0 : u.activeElement);
            });
            _E && d(_E.propsRef.current.value);
          }
          break;
        case F.Space:
          {
            r.preventDefault(), r.stopPropagation();
            var g = n.find(function (E) {
              return E.element.current === (u == null ? void 0 : u.activeElement);
            });
            g && d(g.propsRef.current.value);
          }
          break;
      }
    }),
    q = S(function (r) {
      return C(_objectSpread({
        type: 0
      }, r)), function () {
        return C({
          type: 1,
          id: r.id
        });
      };
    }),
    ue = x(function () {
      return _objectSpread({
        value: s,
        firstOption: R,
        containsCheckedOption: b,
        disabled: p,
        compare: T
      }, v);
    }, [s, R, b, p, T, v]),
    ce = x(function () {
      return {
        registerOption: q,
        change: d
      };
    }, [q, d]),
    fe = {
      ref: M,
      id: O,
      role: "radiogroup",
      "aria-labelledby": U,
      "aria-describedby": D,
      onKeyDown: de
    },
    Te = x(function () {
      return {
        value: s
      };
    }, [s]),
    me = ye(function () {
      if (l !== void 0) return d(l);
    }, [d, l]);
  return /*#__PURE__*/G.createElement(L, {
    name: "RadioGroup.Description"
  }, /*#__PURE__*/G.createElement(h, {
    name: "RadioGroup.Label"
  }, /*#__PURE__*/G.createElement(X.Provider, {
    value: ce
  }, /*#__PURE__*/G.createElement(j.Provider, {
    value: ue
  }, i != null && /*#__PURE__*/G.createElement(Pe, {
    disabled: p,
    data: _defineProperty({}, i, s || "on"),
    overrides: {
      type: "radio",
      checked: s != null
    },
    form: P,
    onReset: me
  }), $({
    ourProps: fe,
    theirProps: y,
    slot: Te,
    defaultTag: Ie,
    name: "RadioGroup"
  })))));
}
var Me = "div";
function Se(o, t) {
  var R;
  var e = J("RadioGroup.Option"),
    a = z("RadioGroup.Option"),
    O = B(),
    _o$id2 = o.id,
    m = _o$id2 === void 0 ? "headlessui-radiogroup-option-".concat(O) : _o$id2,
    P = o.value,
    _o$disabled2 = o.disabled,
    i = _o$disabled2 === void 0 ? e.disabled || !1 : _o$disabled2,
    _o$autoFocus = o.autoFocus,
    f = _o$autoFocus === void 0 ? !1 : _o$autoFocus,
    c = _objectWithoutProperties(o, _excluded2),
    p = W(null),
    I = V(p, t),
    _se3 = se(),
    _se4 = _slicedToArray(_se3, 2),
    y = _se4[0],
    T = _se4[1],
    _le3 = le(),
    _le4 = _slicedToArray(_le3, 2),
    v = _le4[0],
    C = _le4[1],
    n = oe({
      value: P,
      disabled: i
    });
  te(function () {
    return a.registerOption({
      id: m,
      element: p,
      propsRef: n
    });
  }, [m, a, p, n]);
  var U = S(function (b) {
      var d;
      if (ie(b.currentTarget)) return b.preventDefault();
      a.change(P) && ((d = p.current) == null || d.focus());
    }),
    h = ((R = e.firstOption) == null ? void 0 : R.id) === m,
    _Q = Q({
      autoFocus: f
    }),
    D = _Q.isFocusVisible,
    L = _Q.focusProps,
    _Y = Y({
      isDisabled: i
    }),
    A = _Y.isHovered,
    M = _Y.hoverProps,
    l = e.compare(e.value, P),
    s = pe({
      ref: I,
      id: m,
      role: "radio",
      "aria-checked": l ? "true" : "false",
      "aria-labelledby": y,
      "aria-describedby": v,
      "aria-disabled": i ? !0 : void 0,
      tabIndex: function () {
        return i ? -1 : l || !e.containsCheckedOption && h ? 0 : -1;
      }(),
      onClick: i ? void 0 : U,
      autoFocus: f
    }, L, M),
    _ = x(function () {
      return {
        checked: l,
        disabled: i,
        active: D,
        hover: A,
        focus: D,
        autofocus: f
      };
    }, [l, i, A, D, f]);
  return /*#__PURE__*/G.createElement(C, {
    name: "RadioGroup.Description"
  }, /*#__PURE__*/G.createElement(T, {
    name: "RadioGroup.Label"
  }, $({
    ourProps: s,
    theirProps: c,
    slot: _,
    defaultTag: Me,
    name: "RadioGroup.Option"
  })));
}
var He = "span";
function we(o, t) {
  var R;
  var e = J("Radio"),
    a = z("Radio"),
    O = B(),
    m = ve(),
    P = re(),
    _o$id3 = o.id,
    i = _o$id3 === void 0 ? m || "headlessui-radio-".concat(O) : _o$id3,
    f = o.value,
    _o$disabled3 = o.disabled,
    c = _o$disabled3 === void 0 ? e.disabled || P || !1 : _o$disabled3,
    _o$autoFocus2 = o.autoFocus,
    p = _o$autoFocus2 === void 0 ? !1 : _o$autoFocus2,
    I = _objectWithoutProperties(o, _excluded3),
    y = W(null),
    T = V(y, t),
    v = he(),
    C = xe(),
    n = oe({
      value: f,
      disabled: c
    });
  te(function () {
    return a.registerOption({
      id: i,
      element: y,
      propsRef: n
    });
  }, [i, a, y, n]);
  var U = S(function (b) {
      var d;
      if (ie(b.currentTarget)) return b.preventDefault();
      a.change(f) && ((d = y.current) == null || d.focus());
    }),
    _Q2 = Q({
      autoFocus: p
    }),
    h = _Q2.isFocusVisible,
    D = _Q2.focusProps,
    _Y2 = Y({
      isDisabled: c
    }),
    L = _Y2.isHovered,
    A = _Y2.hoverProps,
    M = ((R = e.firstOption) == null ? void 0 : R.id) === i,
    l = e.compare(e.value, f),
    s = pe({
      ref: T,
      id: i,
      role: "radio",
      "aria-checked": l ? "true" : "false",
      "aria-labelledby": v,
      "aria-describedby": C,
      "aria-disabled": c ? !0 : void 0,
      tabIndex: function () {
        return c ? -1 : l || !e.containsCheckedOption && M ? 0 : -1;
      }(),
      autoFocus: p,
      onClick: c ? void 0 : U
    }, D, A),
    _ = x(function () {
      return {
        checked: l,
        disabled: c,
        hover: L,
        focus: h,
        autofocus: p
      };
    }, [l, c, L, h, p]);
  return $({
    ourProps: s,
    theirProps: I,
    slot: _,
    defaultTag: He,
    name: "Radio"
  });
}
var Ne = K(Ue),
  We = K(Se),
  Be = K(we),
  Ve = Ce,
  Ke = Ge,
  Tt = Object.assign(Ne, {
    Option: We,
    Radio: Be,
    Label: Ve,
    Description: Ke
  });
export { Be as Radio, Tt as RadioGroup, Ke as RadioGroupDescription, Ve as RadioGroupLabel, We as RadioGroupOption };